/**
 *  社交聆听
 */
export default [
  {
    path: "/listeningTask",
    name: "listeningTask",
    redirect: "/listeningTask/socialListening",
    component: () => import("@/views/publicSentiment/socialListening/navigationListening.vue"),
    meta: {
      title: "route.sentiment",
      crumbs: "route.social-listening-crumb",
      isLogin: true,
      // 主侧栏直接读取 sidebar 元数据生成一级导航，避免 Layout 里重复定制路由。
      sidebar: { label: "社交聆听", labelKey: "route.social-listening", icon: "Listen", order: 60 },
    },
    children: [
      {
        path: "/listeningTask/socialListening",
        name: "sentimentSocialListening",
        component: () => import("@/views/publicSentiment/socialListening/listenningindex.vue"),
        meta: {
          title: "route.social-listening",
          crumbs: "route.listening-task-crumb",
          isLogin: true,
          sidebar: {
            label: "聆听任务",
            labelKey: "route.listening-task",
            icon: "Listening task",
            order: 10,
            activePaths: ["/listeningTask/socialListening", "/listeningTask/listenningHome"],
          },
        },
      },
      {
        path: "/listeningTask/socialListeningComparison",
        name: "sentimentSocialListeningComparison",
        component: () => import("@/views/publicSentiment/socialListening/listeningComparison.vue"),
        meta: {
          title: "route.listening-comparison",
          crumbs: "route.listening-comparison-crumb",
          isLogin: true,
          sidebar: {
            label: "聆听对比",
            labelKey: "route.listening-comparison",
            icon: "Data Comparison",
            order: 20,
            activePaths: ["/listeningTask/socialListeningComparison", "/listeningTask/listeningComparisonHome"],
          },
        },
      },
      {
        path: "/listeningTask/audienceTask",
        name: "sentimentAudienceTask",
        component: () => import("@/views/publicSentiment/socialListening/audience/audienceTask.vue"),
        meta: {
          title: "route.audience-task",
          crumbs: "route.audience-task-crumb",
          isLogin: true,
          sidebar: {
            label: "受众任务",
            labelKey: "route.audience-task",
            icon: "Audience",
            order: 30,
            activePaths: ["/listeningTask/audienceTask", "/listeningTask/audienceTaskHome"],
          },
        },
      },
      {
        // 舆情-主页管理-社交聆听 -主页详情
        path: "/listeningTask/listenningHome",
        name: "sentimentSocialListeningHome",
        component: () => import("@/views/publicSentiment/socialListening/listenningHome.vue"),
        meta: {
          title: "route.social-listening",
          crumbs: "route.listening-task-home-crumb",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // 舆情-主页管理-聆听对比 - 主页详情
        path: "/listeningTask/listeningComparisonHome",
        name: "sentimentSocialListeningComparisonHome",
        component: () => import("@/views/publicSentiment/socialListening/listeningComparisonHome.vue"),
        meta: {
          title: "route.social-listening",
          crumbs: "route.listening-comparison-home-crumb",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
      {
        // 舆情-主页管理-受众监控-主页详情
        path: "/listeningTask/audienceTaskHome",
        name: "sentimentAudienceTaskHome",
        component: () => import("@/views/publicSentiment/socialListening/audience/taskComponents/audienceHome.vue"),
        meta: {
          title: "route.audience-task",
          crumbs: "route.audience-task-home-crumb",
          isLogin: true,
          needBackBtn: true,
          series: "PlatformAccountData",
        },
      },
    ],
  },
];
